import { Component } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    Card,
    Text,
    ProgressBar,
    BlockStack,
    Banner,
    Button,
    Spinner,
    List,
    DropZone,
    Thumbnail,
    SkeletonBodyText,
    SkeletonDisplayText,
    Tooltip,

} from '@shopify/polaris';
import {
    // CancelSmallMinor,
} from '@shopify/polaris-icons';
import utils from '../../../../utils/utils';
import {
    reqGetImgOptTotal,
    reqGetImageOptDataPage,
    reqGetOptSchedule,
    reqBatchReOptimize,
    reqBatchRestore,
    reqSaveSettings,
    reqStopImageOptTask,
    reqUpdateCustomerClick,
    reqSaveSwitchState,

} from "../../../../api"
import { PAGE_DOMAIN } from '../../../../utils/constants';
import { store } from '../../../../redux/store';
// import './index.css';
import Language from '../../../../i18n/Language';
import OptHistoryTable from './OptHistoryTable';
import { connect } from 'react-redux';
import { setImageAutoSwitchData, setSaveSwitchData } from '../../../../redux/actions/getAppPublicData';
import cloneDeep from 'lodash-es/cloneDeep';
import debounce from 'lodash-es/debounce';
import { setPageData } from '../../../../redux/actions/getAppPageData';
import { showNewMessage } from '@intercom/messenger-js-sdk';
const t = Language;

let timerArr = [], historyArr = [];
class indexClass extends Component {
    state = {
        //页面动作
        loading: true,
        loadingPage: true,
        LanguageRefreshData: false,
        existUser: false, // 是否存在首次设置

        showToast: false,
        showToastText: '',
        showToastIserror: '',
        // 表格条数
        current_PageSize: 5,
        current_PageSize_alt: 5,
        isShowQuotaImage: true, // 额度banner状态

        level: 1, // 等级
        switchLoading: false, // 开关loading
        auto_switch: false,
        isShowAutoState: false, // 是否展示自动状态
        FirstSetActive: false, // 首次设置弹窗状态
        isShowManuallyModal: false, // 手动弹窗状态
        firstSetSheetActive: false, // 抽屉状态

        is_default: 1, // 是否第一次设置
        total_saved_size: 0, // 比特单位
        avg_saved_space: 0,
        avg_saved_percent: 0,
        total_original_size: 0,
        total_compress_size: 0,
        optimize_status: 0,
        un_opt_num: 0, // 待优化
        impressionsUse: 0, // 使用额度
        impressionsAll: 0, // 总额度
        impressionsProportion: 0,  // 占比额度
        freeQuota: 150,  // 免费额度

        image_opt: {}, // 基础设置
        alt_text: {}, // alt设置
        file_name: {}, // 文件名称设置

        isShowImgCompression: false, // 开关状态
        isShowImgAltText: false, // 开关状态
        isShowImgFilename: false, // 开关状态
        productImg: 0, // check状态
        ColImg: false, // check状态
        BlogImg: false, // check状态
        ConvertImg: false, // check状态
        AddWaterImg: false, // check状态
        productAlt: 0, // check状态
        ColAlt: false, // check状态
        BlogAlt: false, // check状态
        blankImgAlt: false, // check状态
        productFile: 0, // check状态
        ColFile: false, // check状态
        BlogFile: false, // check状态
        setSaveLoading: false, // 保存设置loading
        setSaveDisabled: true, // 是否禁用save
        tagSet: {},
        proAltTag: '',    // tag输入框
        colAltTag: '',
        blogAltTag: '',
        proFileTag: '',
        colFileTag: '',
        blogFileTag: '',
        productAltList: [
            {
                content: 'Product title',
                onAction: () => this.addApplyField('Product title', 'ProductAltFixTag')
            },
            {
                content: 'Product vendor',
                onAction: () => this.addApplyField('Product vendor', 'ProductAltFixTag')
            },
            {
                content: 'Product type',
                onAction: () => this.addApplyField('Product type', 'ProductAltFixTag')
            },
            {
                content: 'Price',
                onAction: () => this.addApplyField('Price', 'ProductAltFixTag')
            },
            {
                content: 'Shop name',
                onAction: () => this.addApplyField('Shop name', 'ProductAltFixTag')
            },
            {
                content: 'Product variant',
                onAction: () => this.addApplyField('Product variant', 'ProductAltFixTag')
            },
        ],
        colAltTagList: [
            {
                content: 'Collection title',
                onAction: () => this.addApplyField('Collection title', 'ColAltFixTag')
            },
            {
                content: 'Shop name',
                onAction: () => this.addApplyField('Shop name', 'ColAltFixTag')
            }
        ],
        blogAltTagList: [
            {
                content: 'Blog title',
                onAction: () => this.addApplyField('Blog title', 'BlogAltFixTag')
            },
            {
                content: 'Shop name',
                onAction: () => this.addApplyField('Shop name', 'BlogAltFixTag')
            }
        ],
        productFileList: [
            {
                content: 'Product title',
                onAction: () => this.addApplyField('Product title', 'ProductFileFixTag')
            },
            {
                content: 'Product vendor',
                onAction: () => this.addApplyField('Product vendor', 'ProductFileFixTag')
            },
            {
                content: 'Product type',
                onAction: () => this.addApplyField('Product type', 'ProductFileFixTag')
            },
            {
                content: 'Price',
                onAction: () => this.addApplyField('Price', 'ProductFileFixTag')
            },
            {
                content: 'Shop name',
                onAction: () => this.addApplyField('Shop name', 'ProductFileFixTag')
            },
            {
                content: 'Product variant',
                onAction: () => this.addApplyField('Product variant', 'ProductFileFixTag')
            },
        ],
        colFileTagList: [
            {
                content: 'Collection title',
                onAction: () => this.addApplyField('Collection title', 'ColFileFixTag')
            },
            {
                content: 'Shop name',
                onAction: () => this.addApplyField('Shop name', 'ColFileFixTag')
            }
        ],
        blogFileTagList: [
            {
                content: 'Blog title',
                onAction: () => this.addApplyField('Blog title', 'BlogFileFixTag')
            },
            {
                content: 'Shop name',
                onAction: () => this.addApplyField('Shop name', 'BlogFileFixTag')
            }
        ],

        isShowSheetLoading: true,  // sheet loading
        allTagList: {}, // 初始化tag
        manuallyTabKey: 0, // 手动列表索引
        manuallyTableData: [], // 手动优化图片列表
        manuallyTableRes: {}, // 手动列表总数据
        manuallyQueryVal: '', // 手动搜索value
        mPage: 1, // 手动页码
        mPageSize: 10, // 条数

        showImageUploadBanner: false,
        setUpdateImageWarning: null,
        uploadedFiles: null,
        fileUpload: null,
        imgButton: true,    //图片删除按钮
        imageAddWatermarkPosition: '',
        imageAddWatermarkSize: 0,
        imageAddWatermarkOpacity: 1,

        ProductAltFixTag: {}, // tag输入对象
        ColAltFixTag: {}, // --
        BlogAltFixTag: {}, // --
        ProductFileFixTag: {}, // --
        ColFileFixTag: {}, // --
        BlogFileFixTag: {}, // tag输入对象
        imageAddWatermarkImg: '', // 图片对象数据

        hPage: 1,   // 历史记录 页码
        hPageSize: 10,   // 历史记录 条数
        historyTableRes: {}, // 接口数据
        historyQueryVal: '',   // 历史记录 搜索
        historyTabKey: 0,   // 历史记录 索引
        historyTableData: [], // 表格数据
        historyTabLoading: true, // loading历史记录表
        historyTabLoadingShow: -1,

        isImageCompression: false,  // 当前开关状态
        isConvertImage: false,  // 当前开关状态
        isAddWatermark: false,  // 当前开关状态
        isImageAlttext: false,  // 当前开关状态
        isImageFilename: false,   // 当前开关状态

        tagActive: [], //  是否高亮tag输入框
        ProductAltFixTagPop: false,
        ColAltFixTagPop: false,
        BlogAltFixTagPop: false,
        ProductFileFixTagPop: false,
        ColFileFixTagPop: false,
        BlogFileFixTagPop: false,

        isShowManuallyBtnLoading: false,  // 手动按钮loading
        manuallyTableState: {},
        historyTableState: {},

        progressCp: 0,      // 当前完成优化数量
        progressAll: 0,     // 需要完成总量
        isShowProgress: -1,   // 是否展示进度条
        allOptType: true,       // 是否存在任意一个
        optType: '',          // 优化类型
        optPageType: 0,
        stopLoading: false,

        batchLoading: true,     // 批量操作loading
        historyyPre: false,     // 历史记录分页
        historyNext: false,
        manuallyPre: false,     // 手动分页
        manuallyNext: false,
        initStateBtn: true, // 手动按钮初始化状态
        addTagsProAlt: '',
        addTagsColAlt: '',
        addTagsBlogAlt: '',
        addTagsProFile: '',
        addTagsColFile: '',
        addTagsBlogFile: '',
        isInLoading: false,
        isLocalStorage: false,    // 是否无痕

        exceedUse: 0, // 超出额度
        exceedAll: 0, // 超出额度
        is_capped: false, // 是否可增量
        is_over_quota: false, // 是否开启
        isShowOverCharge: false, // 是否显示增量提示

        questionList: {
            w_image: {
                title: "What is image optimization?",
                tag: ["SEOWILL's image optimization involves techniques such as compression, editing ALT tags, using appropriate file formats, etc., to reduce image file size, improve page loading speed, and optimize SEO search."]
            },
            why_bimage: {
                title: "Why is image optimization necessary?",
                tag: ["Optimizing images can enhance website loading speed, reduce bandwidth consumption, and improve user experience. Websites that load quickly are generally more popular among users and receive better rankings in search engines."]
            },
            // wia_image: {
            //   title: "What is an ALT tag?",
            //   tag: ["ALT tag is an HTML attribute used to provide alternative text descriptions for images. It is used to convey the content of an image to users when the image cannot be displayed or is being read by screen readers."]
            // },
            // wwrite_bimage: {
            //   title: "Why is necessary to write ALT tags?",
            //   tag: ["ALT tags improve accessibility and SEO, describe image content, enhance user experience, and increase search engine visibility."]
            // },
            htm_image: {
                title: "How to manually optimize images?",
                tag: ["First, select the type of images you want to optimize, then click on manual optimization on the page, check the corresponding products, collections, blogs for optimization, and the corresponding results will be displayed below."]
            },
            hta_image: {
                title: "How to automatically optimize images?",
                tag: ["First, select the type of images you want to optimize, then turn on the automatic switch, SEOWILL will automatically optimize images for you 24 hours a day, detect new images automatically, and you don't need to take any further action."]
            },
            his_image: {
                title: "How long are images saved?",
                tag: ["Images optimized by SEOWILL are saved in the SEOWILL system for 30 days, during which you can perform operations such as restoration and re-optimization. If you uninstall SEOWILL, the images will not be restored in Shopify, where images are saved permanently."]
            },
            after_image: {
                title: "[Precautions] After image optimization, your images will have a new URL.",
                tag: ["For image optimization, if only compression is applied, we won't generate a new filename. However, if you choose to modify the filename or add a watermark, the system requires a unique filename; otherwise, Shopify will create a random string. Therefore, after image optimization, a new URL will be generated. To avoid issues, please update the image links used on other platforms accordingly."]
                // tag: ["For image optimization, a unique file name is required, otherwise Shopify will create a random string. Therefore, after image optimization, a new URL will be generated. To avoid issues, please modify the image links used by other platforms."]
            },
            wtype_image: {
                title: "What types of images can we optimize?",
                tag: ["SEOWILL can automatically compress product, collection, and blog post feature images, but does not support optimization of content images and homepage carousel images. If you need optimization for these, you will need to manually optimize the images before uploading."]
            },
            will_image: {
                title: "Will it detect new images?",
                tag: ["SEOWILL automatically optimizes new product, collection, and blog folder images upon upload. No additional action is required."]
            },
            can_image: {
                title: "How can I restore the original images?",
                tag: ["Select the image from the list, click on the restore button, and the system will restore the image to its initial state."]
            },
            wdmy_image: {
                title: "Why do my optimized images contain random numbers?",
                tag: ["Random numbers are added to the end of the file name to ensure uniqueness and avoid overwriting images with the same file name. This does not affect SEO."]
            },
        },
        isShowMaxLimitState: false,
        total_speed_increase: 0,
        isShowGetMore: true,
        isShowCwAdverImage: false,  // cw广告
        isShowUnderFunc: false,
        impressionsPro: 0,  // 进度条
        exceedPro: 0,

        isShowSecTip: false,    // 是否显示提示
        isShowPop: false,
        isGuideTip: false,
        imageSecTip: false,
        reduxLoading: true,
        remainQuota: 0,
        handleTypePro: -1,
        handleTypeCol: -1,
        handleTypeBlog: -1,
        isReOpt: false,         // 是否重新优化 - 选择
        isDisabledReOpt: false,     // 是否禁点
    };

    callback = (val) => {
        this.setState({
            LanguageRefreshData: val
        })
    }

    UNSAFE_componentWillMount() {
        let quotaBannerImage = null;
        let isLocalStorage = null;
        let isShowGetMore = true;
        let imageSecTip = false;
        try {
            isLocalStorage = true;
            quotaBannerImage = sessionStorage.getItem('quotaBannerImage');
            isShowGetMore = !Boolean(sessionStorage.getItem('getMoreQuotaBanner'));
            imageSecTip = !Boolean(sessionStorage.getItem('imageSecTip'));
        } catch {
            quotaBannerImage = 0;
            isLocalStorage = false;
        }
        this.setState({
            isShowQuotaImage: !Boolean(Number(quotaBannerImage)),
            isLocalStorage: isLocalStorage,
            isShowGetMore,
            imageSecTip,

        })
    }

    //进入页面调用接口
    componentDidMount() {
        const _params = this.props.location;
        let _page = store.getState().page.pageInit;
        this.getProductStatistics(true, _page?.ImageOptimization);
        this.getOptSchedule();

        // 获取开关状态
        let _store = store.getState().public;
        let switchData = _store.publicInit.head_data?.switch_data;
        this.setState({
            isShowCwAdverImage: !Boolean(switchData?.cwAdverImageState),
            isGuideTip: Boolean(_params?.query === "showPopover"),
        })
        // 传递子事件
        if (this.props.setHistoryAction) {
            this.props.setHistoryAction(this);
        }
    }

    // 获取额度及优化数据
    getOptSchedule = debounce(async (isGetData = false) => {
        let { historyTabKey } = this.state;
        let params = {
            data_type: historyTabKey + 1
        }
        // if(isGetData) {
        //   this.getOptHistoryTable();
        // }
        const res = await reqGetOptSchedule(params);
        if (res && res.product) {
            let optTypes = historyTabKey === 0 ? res.product?.process_type : historyTabKey === 1 ? res.collection?.process_type : res.article?.process_type;
            let optPageTypes = historyTabKey === 0 ? res.product?.page_type : historyTabKey === 1 ? res.collection?.page_type : res.article?.page_type;
            let allOptType = (!Boolean(res.product?.process_result) && (res.product?.process_type === 'restore' || (res.product?.process_type === 're-Optimize' && res.product?.page_type === 0)) && Boolean(res.product?.opt_total)) || (!Boolean(res.collection?.process_result) && (res.collection?.process_type === 'restore' || (res.collection?.process_type === 're-Optimize' && res.collection?.page_type === 0)) && Boolean(res.collection?.opt_total)) || (!Boolean(res.article?.process_result) && (res.article?.process_type === 'restore' || (res.article?.process_type === 're-Optimize' && res.article?.page_type === 0)) && Boolean(res.article?.opt_total));
            let showOvercharge = Boolean(
                res.impressions_use >= res.impressions_all
                && res.impressions_all >= 6000
                && store.getState().public?.level === 3
                && Boolean(res?.is_capped)
                && res.img_usage_use >= res.img_usage_all
            )
            // 计算进度条
            let impressionsProVal = Number(100 * (res.impressions_use / res.impressions_all));
            let exceedProVal = Number(100 * (res.img_usage_use / res.img_usage_all));
            let impressionsAll = res.impressions_all;
            let impressionsUse = res.impressions_use;
            let exceedAll = res?.img_usage_all === undefined ? -1 : res.img_usage_all;
            let exceedUse = res?.img_usage_use === undefined ? -1 : res.img_usage_use;
            this.setState({
                impressionsUse,
                impressionsAll,
                exceedUse,
                exceedAll,
                exceedPro: Number((exceedProVal > 100 ? 100 : exceedProVal).toFixed(2)),
                impressionsPro: Number((impressionsProVal > 100 ? 100 : impressionsProVal).toFixed(2)),
                is_capped: Boolean(res?.is_capped),
                is_over_quota: Boolean(res?.is_over_quota),
                impressionsProportion: res.impressions_all === 0 ? 0 : (res.impressions_use / res.impressions_all) * 100,
                optType: optTypes,
                optPageType: optPageTypes,
                allOptType: allOptType,

                isShowOverCharge: showOvercharge && !Boolean(res?.is_over_quota),
                isShowMaxLimitState: showOvercharge && Boolean(res?.is_over_quota) && res.img_usage_use > 0 && res.is_excess_limit,
                remainQuota: ((impressionsAll - impressionsUse) + (exceedAll - exceedUse)) > 0 ? ((impressionsAll - impressionsUse) + (exceedAll - exceedUse)) : 0,
                handleTypePro: Number(res.product.handle_type || -1),
                handleTypeCol: Number(res.collection.handle_type || -1),
                handleTypeBlog: Number(res.article.handle_type || -1),
            }, () => {
                let optIn = historyTabKey === 0 ? Number(res.product?.opt_in || 0) : historyTabKey === 1 ? Number(res.collection?.opt_in || 0) : Number(res.article?.opt_in || 0);
                let total = historyTabKey === 0 ? Number(res.product?.opt_total || 0) : historyTabKey === 1 ? Number(res.collection?.opt_total || 0) : Number(res.article?.opt_total || 0);
                let result = historyTabKey === 0 ? Number(res.product?.process_result || 0) : historyTabKey === 1 ? Number(res.collection?.process_result || 0) : Number(res.article?.process_result || 0);

                if (total && result === 1) {
                    // 判断是否该提示完成
                    let opt_type = historyTabKey === 0 ? 'products images' : historyTabKey === 1 ? 'collections' : historyTabKey === 2 ? 'blogs' : 'others';
                    this.props.toggleToast(`${total} ${opt_type} ${optTypes === 'restore' ? 'restored' : 'optimized'}`, false);
                    this.deleteTimeFunc();
                    this.setState({
                        isShowManuallyBtnLoading: false,
                        isInLoading: false,
                        isShowProgress: -1,
                        optType: '',
                        progressCp: 0,
                        progressAll: 0,
                        initStateBtn: false,
                        allOptType: false,
                    }, () => {
                        setTimeout(() => {
                            this.deleteTimeFunc();
                            this.getOptHistoryTable();
                            this.deleteTimeFunc();
                        }, 3000);
                    })
                } else if (total > 0) {
                    this.setState({
                        isShowManuallyBtnLoading: true,
                        isShowProgress: historyTabKey,
                        progressCp: total - optIn,
                        progressAll: total,
                    })
                    // 判断是否该轮询
                    if (timerArr.length === 0) {
                        let timer = setInterval(() => {
                            this.getOptSchedule();
                        }, 6000);
                        timerArr.push(timer)
                    }
                } else {
                    let isShowState = Boolean((Number(res.product.opt_total) > 0 && Number(res.product.process_result) !== 1) || (Number(res.collection.opt_total) > 0 && Number(res.collection.process_result) !== 1) || (Number(res.article.opt_total) > 0 && Number(res.article.process_result) !== 1))
                    this.setState({
                        isShowProgress: -1,
                        initStateBtn: false,
                        isShowManuallyBtnLoading: isShowState,
                        isInLoading: false,
                    })
                }

                // 判断是否增量提示
                if (this.state.isShowOverCharge) {
                    window.scrollTo(0, 0);
                    this.changeBannerBackground(0); // 进行banner背景闪烁
                }
            })
        } else {
            this.props.toggleToast(res?.msg || t("Try again later"));
        }
    }, 500)

    // 切换背景
    changeBannerBackground = (nums) => {
        if (nums !== 2) {
            let objs = document.querySelector('div.overChargeBanner > div > div > div > div:nth-child(1)');
            if (objs) {
                setTimeout(() => {
                    if (objs) {
                        objs.style.background = '#ffd79d';
                        setTimeout(() => {
                            objs.style.background = '#ffb800';
                            this.changeBannerBackground(nums + 1);
                        }, 300)
                    }
                }, 300)
            } else {
                setTimeout(() => {
                    this.changeBannerBackground(0);
                }, 500)
            }
        }
    }

    // 删除订阅器
    deleteTimeFunc = () => {
        timerArr.map(timer => {
            clearInterval(timer);
            timerArr.pop();
            return false;
        })
    }

    // 设置tag
    setDefaultTag = () => {
        let { proAltTag, colAltTag, blogAltTag, proFileTag, colFileTag, blogFileTag, productAltList, colAltTagList, blogAltTagList, productFileList, colFileTagList, blogFileTagList } = this.state;
        let allTagList = {
            proAltTag: Boolean(proAltTag) ? proAltTag : `[[{"value":"${productAltList[0]['content']}"}]] - [[{"value":"${productAltList[4]['content']}"}]]`, // product
            colAltTag: Boolean(colAltTag) ? colAltTag : `[[{"value":"${colAltTagList[0]['content']}"}]] - [[{"value":"${colAltTagList[1]['content']}"}]]`, // collection
            blogAltTag: Boolean(blogAltTag) ? blogAltTag : `[[{"value":"${blogAltTagList[0]['content']}"}]] - [[{"value":"${blogAltTagList[1]['content']}"}]]`, // blog
            proFileTag: Boolean(proFileTag) ? proFileTag : `[[{"value":"${productFileList[0]['content']}"}]] - [[{"value":"${productFileList[4]['content']}"}]]`, // product
            colFileTag: Boolean(colFileTag) ? colFileTag : `[[{"value":"${colFileTagList[0]['content']}"}]] - [[{"value":"${colFileTagList[1]['content']}"}]]`, // collection
            blogFileTag: Boolean(blogFileTag) ? blogFileTag : `[[{"value":"${blogFileTagList[0]['content']}"}]] - [[{"value":"${blogFileTagList[1]['content']}"}]]`, // blog
        }
        this.setState({
            proAltTag: allTagList['proAltTag'],
            colAltTag: allTagList['colAltTag'],
            blogAltTag: allTagList['blogAltTag'],
            proFileTag: allTagList['proFileTag'],
            colFileTag: allTagList['colFileTag'],
            blogFileTag: allTagList['blogFileTag'],
            allTagList,
        })
    }

    // 转成tag输入框的数据格式
    setDefaultTagFormat = (type, data) => {
        let val = "";
        if (Boolean(data) && data !== '') {
            val = cloneDeep(data);
            val = val.replace(/\n/g, '');
            if (type === 'product') {
                val = val.replace(/%product_title%/g, '[[{"value":"Product title"}]]')
                    .replace(/%product_vendor%/g, '[[{"value":"Product vendor"}]]')
                    .replace(/%product_type%/g, '[[{"value":"Product type"}]]')
                    .replace(/%shop_name%/g, '[[{"value":"Shop name"}]]')
                    .replace(/%price%/g, '[[{"value":"Price"}]]')
                    .replace(/%product_variant%/g, '[[{"value":"Product variant"}]]');
            } else if (type === 'collection') {
                val = val.replace(/%collection_title%/g, '[[{"value":"Collection title"}]]')
                    .replace(/%shop_name%/g, '[[{"value":"Shop name"}]]');
            } else if (type === 'blog') {
                val = val.replace(/%blog_title%/g, '[[{"value":"Blog title"}]]')
                    .replace(/%shop_name%/g, '[[{"value":"Shop name"}]]');
            } else { }
        }

        return val;
    }

    // 获取产品页面统计数据
    getProductStatistics = async (isGetTable = true, _reduxData = null) => {
        let res = {};
        if (_reduxData) {
            res = _reduxData;
        } else {
            res = await reqGetImgOptTotal({ handle_type: 1 });
        }
        if (res.ack === 1) {
            if (_reduxData) {
                this.getProductStatistics(true, null);
            }
            this.props.getPageDataRedux(res);
            let t = res.total;
            let set = res.settings;
            let first = res.settings.is_default;
            // 计算进度条
            let impressionsProVal = Number(100 * (res.opt_schedule.impressions_use / res.opt_schedule.impressions_all));
            let exceedProVal = Number(100 * (res.opt_schedule?.img_usage_use / res.opt_schedule?.img_usage_all));
            let impressionsAll = res.opt_schedule.impressions_all;
            let impressionsUse = res.opt_schedule.impressions_use;
            let exceedAll = res.opt_schedule?.img_usage_all === undefined ? -1 : res.opt_schedule.img_usage_all;
            let exceedUse = res.opt_schedule?.img_usage_use === undefined ? -1 : res.opt_schedule.img_usage_use;
            this.setState({
                total_saved_size: this.changeBitInfo(t.total_saved_size),
                avg_saved_space: this.changeBitInfo(t.avg_saved_space),
                total_speed_increase: this.changeSaveTime(t.total_saved_size),
                avg_saved_percent: Number(t.total_original_size) === 0 ? 0 : Number(((Number(t.total_saved_size) / Number(t.total_original_size)) * 100).toFixed(2)),
                total_original_size: Number(t.total_original_size),
                total_compress_size: Number(t.total_compress_size),
                un_opt_num: Number(t.un_opt_num),
                optimize_status: 0,
                is_default: first, // 是否第一次设置
                FirstSetActive: res.settings.is_default === 1,
                // firstSetSheetActive: res.settings.is_default === 1 ? true : false, // 第一次设置默认弹出
                impressionsUse,
                impressionsAll,
                exceedUse,
                exceedAll,
                exceedPro: Number((exceedProVal > 100 ? 100 : exceedProVal).toFixed(2)),
                impressionsPro: Number((impressionsProVal > 100 ? 100 : impressionsProVal).toFixed(2)),
                is_capped: Boolean(res.opt_schedule?.is_capped),
                is_over_quota: Boolean(res.opt_schedule?.is_over_quota),

                auto_switch: Boolean(res.settings.auto_switch), // 自动状态
                isShowAutoState: Boolean(res.settings.alt_text?.switch), // 自动开关状态
                // 设置
                image_opt: set.image_opt,
                alt_text: set.alt_text,
                file_name: set.file_name,

                isShowImgCompression: Boolean(set.image_opt?.switch), // 开关状态
                isShowImgAltText: Boolean(set.alt_text?.switch), // 开关状态
                isShowImgFilename: Boolean(set.file_name?.switch), // 开关状态
                productImg: set.image_opt?.product,
                ColImg: Boolean(set.image_opt?.collection),
                BlogImg: Boolean(set.image_opt?.blogs),
                ConvertImg: Boolean(set.image_opt?.pngtojpg),
                AddWaterImg: Boolean(set.image_opt?.watermark?.switch),
                imageAddWatermarkPosition: set.image_opt?.watermark?.position,  // 水印参数
                imageAddWatermarkSize: Number(set.image_opt?.watermark?.image_height) * 100,
                imageAddWatermarkOpacity: set.image_opt?.watermark?.opacity,
                imageAddWatermarkImg: set.image_opt?.watermark?.logo,
                productAlt: set.alt_text?.product,
                ColAlt: Boolean(set.alt_text?.collection),
                BlogAlt: Boolean(set.alt_text?.blogs),
                blankImgAlt: Boolean(set.alt_text?.blank_replace),
                productFile: set.file_name?.product,
                ColFile: Boolean(set.file_name?.collection),
                BlogFile: Boolean(set.file_name?.blogs),
                proAltTag: this.setDefaultTagFormat('product', set.alt_text?.product_rule),
                colAltTag: this.setDefaultTagFormat('collection', set.alt_text?.collection_rule),
                blogAltTag: this.setDefaultTagFormat('blog', set.alt_text?.blogs_rule),
                proFileTag: this.setDefaultTagFormat('product', set.file_name?.product_rule),
                colFileTag: this.setDefaultTagFormat('collection', set.file_name?.collection_rule),
                blogFileTag: this.setDefaultTagFormat('blog', set.file_name?.blogs_rule),

                // isShowManuallyBtnLoading: res.opt_schedule.opt_total > 0 && res.opt_schedule.process_result !== 1 ? true : false,
                isShowOverCharge: Boolean(res.opt_schedule.impressions_use >= res.opt_schedule.impressions_all && res.opt_schedule.impressions_all >= 6000 && store.getState().public?.level === 3 && Boolean(res.opt_schedule?.is_capped) && !Boolean(res.opt_schedule?.is_over_quota) && res.opt_schedule.img_usage_use >= res.opt_schedule.img_usage_all),

                level: store.getState().public?.level,
                loadingPage: false,
                reduxLoading: Boolean(_reduxData),
                historyTabLoadingShow: Boolean(_reduxData) ? false : this.state.historyTabLoadingShow,
                remainQuota: ((impressionsAll - impressionsUse) + (exceedAll - exceedUse)) > 0 ? ((impressionsAll - impressionsUse) + (exceedAll - exceedUse)) : 0,
                handleTypePro: Number(res.opt_schedule.product.handle_type || -1),
                handleTypeCol: Number(res.opt_schedule.collection.handle_type || -1),
                handleTypeBlog: Number(res.opt_schedule.article.handle_type || -1),
            }, () => {
                this.props.setImageAutoSwitch({ type: 'imageAltAuto', value: Boolean(res.settings.alt_text?.switch) })
                this.handleDropImage(0, '', set.image_opt?.watermark?.logo);
                if (first === 0 && isGetTable && !Boolean(_reduxData)) {
                    // 判断是否请求优化历史记录表格数据
                    this.getOptHistoryTable();
                } else {
                    this.setState({
                        historyTabLoadingShow: false
                    }, () => {
                        // 动画过渡
                        setTimeout(() => {
                            this.setState({ isShowPop: true })
                        }, 200)
                    })
                }

                // 判断是否轮询
                if (historyArr.length === 0 && Boolean(res.settings.alt_text?.switch)) {
                    // 轮询列表
                    let timer = setInterval(() => {
                        this.getOptHistoryTable(false);
                    }, 5000)
                    historyArr.push(timer)
                } else {
                    // 清除
                    if (!Boolean(res.settings.alt_text?.switch)) {
                        this.clearHistoryArr();
                    }
                }
            })
        } else {
            this.props.toggleToast(res.message, true);
        }
    }

    // 获取历史记录数据
    getOptHistoryTable = debounce(async (isLoading = true) => {
        let { hPage, hPageSize, historyTabKey, historyQueryVal, is_default, } = this.state;
        if (is_default === 1) {
            this.setState({
                historyTabLoading: false,
                historyTabLoadingShow: false,
            })
            return false
        } else {
            if (isLoading) {
                this.setState({
                    historyTabLoading: true,
                })
            }
            let params = {
                page: hPage,
                pageSize: hPageSize,
                title: historyQueryVal,
                data_type: historyTabKey + 1,
                page_type: 0, // 历史记录
                handle_type: 1,
            }
            const res = await reqGetImageOptDataPage(params);
            if (res.ack === 1) {
                let listData = cloneDeep(res.data.data);
                listData.forEach(item => {
                    item['restoreLoadingId'] = [];
                    item['downloadLoadingId'] = [];
                    if (historyTabKey === 0 && Boolean(item?.is_delete)) {
                        item['disabled'] = true;
                    } else if ([1, 2].includes(historyTabKey) && (Boolean(item?.is_delete) || Boolean(item.image?.is_overdue))) {
                        item['disabled'] = true;
                    } else if (historyTabKey === 3 && (Boolean(item?.is_delete) || Boolean(item?.is_overdue))) {
                        item['disabled'] = true;
                    } else {
                        item['disabled'] = false;
                    }
                })
                this.setState({
                    historyTableRes: res.data,
                    historyTableData: listData,
                    historyyPre: res.data.current_page === 1 ? false : true, // 是否存在上一页状态
                    historyNext: res.data.current_page >= Math.ceil(res.data.total / res.data.per_page) ? false : true, // 是否存在下一页状态
                })
            } else {
                this.props.toggleToast(res.msg, true);
            }

            this.setState({
                historyTabLoading: false,
                batchLoading: false,
                historyTabLoadingShow: false,
            }, () => {

                // 动画过渡
                setTimeout(() => {
                    this.setState({ isShowPop: true })
                }, 200)
            })
        }
    }, 500)

    // 比特转换
    changeBitInfo = (limit) => {
        let size = "";
        if (limit < 1 * 1024 * 1024) {
            //小于0.1MB，则转化成KB 
            size = (limit / 1024).toFixed(2) + "KB"
        } else if (limit < 1 * 1024 * 1024 * 1024) {
            //小于0.1GB，则转化成MB 
            size = (limit / (1024 * 1024)).toFixed(2) + "MB"
        } else {
            //其他转化成GB 
            size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
        }
        return size;
    }

    // 时间转换
    changeSaveTime = (limit) => {
        let time = Number((Number((limit / 2621440).toFixed(1)) * 0.1).toFixed(1));
        let formatTime;
        if (time < 60) {
            formatTime = `${time}s`;
        } else if (time < 3600) {
            let minutes = Math.floor(time / 60);
            let seconds = (time % 60).toFixed(1);
            formatTime = `${minutes.toFixed(0)}m ${seconds}s`;
        } else {
            let hours = Math.floor(time / 3600);
            let minutes = Math.floor((time % 3600) / 60);
            let seconds = (time % 60).toFixed(1);
            formatTime = `${hours}h ${minutes.toFixed(0)}m ${seconds}s`;
        }
        return formatTime;
    }

    // 清除历史记录定时器
    clearHistoryArr = () => {
        historyArr.map(timer => {
            clearInterval(timer);
            historyArr.pop();
            return false;
        })
    }

    // 打开首次设置窗体
    openFirstSetUp = () => {
        this.setState({
            FirstSetActive: false,
        }, () => {
            this.openSettingCard(2)
        })
    }

    // 打开手动设置
    openManuallyOpt = () => {
        this.setState({
            isShowManuallyModal: true,
            isShowManuallyLoading: true,
        }, () => {
            this.getManuallyData();
        })
    }

    // 搜索
    setQueryValue = (val) => {
        this.setState({
            queryValue: val
        })
    }

    // 打开设置面板
    openSettingCard = (type) => {
        let { isGuideTip } = this.state;
        utils.routeJump(this, '/speedOpt/PageSpeed/settings', null, isGuideTip ? 'showPopover' : '')
    }
    // openSettingCard = (type) => {
    //   let { is_default, image_opt } = this.state;
    //   if (is_default === 1 && type === 1) {
    //     // 第一次设置弹窗
    //     this.setState({
    //       FirstSetActive: true,
    //       setSaveDisabled: false,
    //     })
    //   } else {
    //     // 后续设置抽屉
    //     this.setState({
    //       firstSetSheetActive: true,
    //     }, () => {
    //       if(is_default === 1) {
    //         this.setState({
    //           setSaveDisabled: false,
    //         })
    //       }
    //       this.handleDropImage(0, '', image_opt?.watermark?.logo);
    //       this.setDefaultTag();
    //     })
    //   }

    //   // 过渡数据渲染时间
    //   setTimeout(() => {
    //     this.setState({
    //       isShowSheetLoading: false,
    //     })
    //   }, 500)
    // }

    // 打开设置
    openSetupBox = () => {
        this.setState({
            isShowManuallyModal: false,
        }, () => {
            this.openFirstSetUp(2);
        })
    }

    // 批量操作手动列表数据
    handleOptManaully = () => {
        this.setState({
            isShowManuallyModal: false,
            isInLoading: true,
            manuallyQueryVal: '',
            isShowManuallyBtnLoading: true,
        }, () => {
            this.optImageData();
        })
    }

    // 发起图片优化
    optImageData = () => {
        let { manuallyTabKey, manuallyTableState, } = this.state;
        let dataIdList = [];
        manuallyTableState[0].forEach(item => {
            dataIdList.push({
                data_id: item
            })
        })
        this.setState({
            historyTabKey: manuallyTabKey,
            isShowProgress: manuallyTabKey,
            optType: '',
        }, async () => {
            let params = {
                data_type: manuallyTabKey + 1,
                data_list: dataIdList,
                re_opt_type: manuallyTableState[1] ? 'all' : '',
                page_type: 1,
            }
            this.getOptHistoryTable();
            const res = await reqBatchReOptimize(params);
            if (res.ack === 1) {
                setTimeout(() => {
                    this.getOptSchedule();
                }, 3000)
            } else {
                this.props.toggleToast(res.msg, true);
            }
        })
    }

    // 获取上传组件事件
    getEventAction = (e) => {
        this.$uploadEvent = e;
    }

    // 状态切换 正负
    handleStateChange = (name, val) => {
        this.setState({
            [name]: val,
        })

        // 首次设置
        if (name === 'firstSetSheetActive') {
            setTimeout(() => {
                this.setState({
                    isShowSheetLoading: true,
                })
            }, 300)
        }

        // 抽屉弹窗
        if (['isShowImgCompression', 'isShowImgAltText', 'isShowImgFilename'].includes(name)) {
            this.setState({
                setSaveDisabled: false,
            })
        }

        // 手动弹窗
        if (name === 'isShowManuallyModal') {
            this.setState({
                mPage: 1,
                mPageSize: 10,
                manuallyTabKey: 0,
                manuallyQueryVal: '',
            })
        }
    }

    // 设置 check
    changeCheckState = (val, name) => {
        this.setState({
            setSaveDisabled: false,
        }, () => {
            if (name.indexOf('product') > -1) {
                let names = name.split('-')[0];
                this.setState({
                    [names]: !Boolean(val) ? 0 : (name.indexOf('One') > -1 && Boolean(val)) ? 1 : 2,
                })
            } else if (name === 'ConvertImg_item') {
                this.setState({
                    ConvertImg: Boolean(val)
                })
            } else if (name === 'AddWaterImg') {
                this.setState({
                    showImageUploadBanner: val,
                    [name]: Boolean(val)
                }, () => {
                    if (!Boolean(val)) {
                        this.deleteImage();
                        this.setState({
                            imageAddWatermarkImg: ''
                        })
                    }
                })
            } else {
                this.setState({
                    [name]: Boolean(val)
                })
            }
        })
    }

    // 选择对应字段
    addApplyField = (type, name) => {
        let { proAltTag, colAltTag, blogAltTag, proFileTag, colFileTag, blogFileTag } = this.state;
        // 删除对应提示
        let curActive = cloneDeep(this.state.tagActive);
        if (curActive.includes(name)) {
            curActive.splice(curActive.indexOf(name), 1);
        }
        // 对象赋值
        let setObj =
            name === 'ProductAltFixTag' ? {
                proAltTag: !Boolean(proAltTag?.length) ? `[[{"value":"${type}"}]]` : `${proAltTag} [[{"value":"${type}"}]]`,
                addTagsProAlt: !Boolean(proAltTag?.length) ? `[[{"value":"${type}"}]]` : `${proAltTag} [[{"value":"${type}"}]]`
            } :
                name === 'ColAltFixTag' ? {
                    colAltTag: !Boolean(colAltTag?.length) ? `[[{"value":"${type}"}]]` : `${colAltTag} [[{"value":"${type}"}]]`,
                    addTagsColAlt: !Boolean(colAltTag?.length) ? `[[{"value":"${type}"}]]` : `${colAltTag} [[{"value":"${type}"}]]`,
                } :
                    name === 'BlogAltFixTag' ? {
                        blogAltTag: !Boolean(blogAltTag?.length) ? `[[{"value":"${type}"}]]` : `${blogAltTag} [[{"value":"${type}"}]]`,
                        addTagsBlogAlt: !Boolean(blogAltTag?.length) ? `[[{"value":"${type}"}]]` : `${blogAltTag} [[{"value":"${type}"}]]`,
                    } :
                        name === 'ProductFileFixTag' ? {
                            proFileTag: !Boolean(proFileTag?.length) ? `[[{"value":"${type}"}]]` : `${proFileTag} [[{"value":"${type}"}]]`,
                            addTagsProFile: !Boolean(proFileTag?.length) ? `[[{"value":"${type}"}]]` : `${proFileTag} [[{"value":"${type}"}]]`,
                        } :
                            name === 'ColFileFixTag' ? {
                                colFileTag: !Boolean(colFileTag?.length) ? `[[{"value":"${type}"}]]` : `${colFileTag} [[{"value":"${type}"}]]`,
                                addTagsColFile: !Boolean(colFileTag?.length) ? `[[{"value":"${type}"}]]` : `${colFileTag} [[{"value":"${type}"}]]`,
                            } :
                                name === 'BlogFileFixTag' ? {
                                    blogFileTag: !Boolean(blogFileTag?.length) ? `[[{"value":"${type}"}]]` : `${blogFileTag} [[{"value":"${type}"}]]`,
                                    addTagsBlogFile: !Boolean(blogFileTag?.length) ? `[[{"value":"${type}"}]]` : `${blogFileTag} [[{"value":"${type}"}]]`,
                                } : {};

        setObj[`${name}Pop`] = !Boolean(this.state[`${name}Pop`]);
        setObj['tagActive'] = curActive;
        setObj['setSaveDisabled'] = false;
        this.setState(setObj);
    }

    // 获取tag输入框对象
    setTagifyData = (data, name) => {
        this.setState({
            [name]: data[0],
        })
        this.$name = data[1];
    }

    // 输入
    tagInputData = debounce((e, name) => {
        let curActive = cloneDeep(this.state.tagActive);
        const tagCompare = {
            proAltTag: "ProductAltFixTag",
            colAltTag: "ColAltFixTag",
            blogAltTag: "BlogAltFixTag",
            proFileTag: "ProductFileFixTag",
            colFileTag: "ColFileFixTag",
            blogFileTag: "BlogFileFixTag",
        }
        if (curActive.includes(tagCompare[name])) {
            curActive.splice(curActive.indexOf(tagCompare[name]), 1);
        }
        let value = "";
        if (e.type === "input") {
            value = e.detail.textContent;
            if (e.detail.tagify.value.length > 0) {
                e.detail.tagify.value.forEach(item => {
                    value = value.replace(new RegExp(`([^"])${item.value}([^"])`, 'g'), `$1[[{"value":"${item.value}"}]]$2`)
                })
            }
        } else {
            value = e.detail?.value;
            if (e.type === "remove") {
                value = e.detail.tagify.state.lastOriginalValueReported;
            }
        }
        this.setState({
            [name]: Boolean(value) ? value.replace(/[\n\u200B]/g, "") : '',
            tagActive: curActive,
            setSaveDisabled: false,
        })
    }, 100)

    // 无痕模式 - 输入
    tagInputDataTraceless = (val, name) => {
        let curActive = cloneDeep(this.state.tagActive);
        const tagCompare = {
            proAltTag: "ProductAltFixTag",
            colAltTag: "ColAltFixTag",
            blogAltTag: "BlogAltFixTag",
            proFileTag: "ProductFileFixTag",
            colFileTag: "ColFileFixTag",
            blogFileTag: "BlogFileFixTag",
        }
        if (curActive.includes(tagCompare[name])) {
            curActive.splice(curActive.indexOf(tagCompare[name]), 1);
        }
        let tagType = ['proAltTag', 'proFileTag'].includes(name) ? 'product' : ['colAltTag', 'colFileTag'].includes(name) ? 'collection' : 'blog';
        let tagVal = this.setDefaultTagFormat(tagType, val);
        this.setState({
            [name]: Boolean(tagVal) ? tagVal.replace(/[\n\u200B]/g, "") : '',
            tagActive: curActive,
            setSaveDisabled: false,
        })
    }

    // 改变tag下拉框状态
    changeSelectPop = (id) => {
        let name = `${id}Pop`;
        const tagState = {
            ProductAltFixTagPop: false,
            ColAltFixTagPop: false,
            BlogAltFixTagPop: false,
            ProductFileFixTagPop: false,
            ColFileFixTagPop: false,
            BlogFileFixTagPop: false,
        }
        tagState[name] = !Boolean(this.state[name]);
        this.setState(tagState);
    }

    // 格式化tag数据
    changeTagFormat = (type, data) => {
        let val = cloneDeep(data);
        val = val.replace(/\n/g, '');
        if (type === 'product') {
            val = val.replace(/\[\[{"value":"Product title"}\]\]/g, '%product_title%')
                .replace(/\[\[{"value":"Product vendor"}\]\]/g, '%product_vendor%')
                .replace(/\[\[{"value":"Product type"}\]\]/g, '%product_type%')
                .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shop_name%')
                .replace(/\[\[{"value":"Price"}\]\]/g, '%price%')
                .replace(/\[\[{"value":"Product variant"}\]\]/g, '%product_variant%');
        } else if (type === 'collection') {
            val = val.replace(/\[\[{"value":"Collection title"}\]\]/g, '%collection_title%')
                .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shop_name%');
        } else if (type === 'blog') {
            val = val.replace(/\[\[{"value":"Blog title"}\]\]/g, '%blog_title%')
                .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shop_name%');
        } else { }

        return val;
    }

    // 改版手动tab
    changeManuallyTab = (e) => {
        this.setState({
            manuallyTabKey: e,
            manuallyTableData: [],
            mPage: 1,
            mPageSize: 10,
            isShowManuallyLoading: true,
            manuallyQueryVal: '',
        }, () => {
            this.getManuallyData();
        })
    }

    // 手动弹窗搜索
    changeManuallyQueryVal = (val) => {
        this.setState({
            manuallyQueryVal: val,
        }, () => {
            this.getManuallyData();
        })
    }

    // 手动 分页
    changeManuallyPageData = (s) => {
        this.setState({
            mPage: Number(s),
            isShowManuallyLoading: true,
        }, () => {
            this.getManuallyData();
        })
    }

    // 手动 页数
    changeManuallyPageSizeData = (s) => {
        this.setState({
            mPage: 1,
            mPageSize: Number(s),
            isShowManuallyLoading: true,
        }, () => {
            this.getManuallyData();
        })
    }

    // 获取手动列表数据
    getManuallyData = debounce(async () => {
        let { mPage, mPageSize, manuallyTabKey, manuallyQueryVal, is_default } = this.state;
        let curSwitchState = this.setSwitchState(manuallyTabKey);
        if (is_default === 1 || !curSwitchState) {
            this.setState({
                isShowManuallyLoading: false,
            })
            return false
        } else {
            this.setState({
                isShowManuallyLoading: true,
            })
            let params = {
                page: mPage,
                pageSize: mPageSize,
                title: manuallyQueryVal,
                data_type: manuallyTabKey + 1,
                page_type: 1
            }
            const res = await reqGetImageOptDataPage(params);
            if (res.ack === 1) {
                let list = cloneDeep(res.data);
                list['data'].forEach(item => {
                    item['id'] = manuallyTabKey === 0 ? item['prod_id'] : manuallyTabKey === 1 ? item['coll_id'] : item['art_id'];
                })
                this.setState({
                    manuallyTableRes: list,
                    manuallyTableData: list.data,
                    manuallyPre: res.data.current_page === 1 ? false : true, // 是否存在上一页状态
                    manuallyNext: res.data.current_page >= Math.ceil(res.data.total / res.data.per_page) ? false : true, // 是否存在下一页状态
                })
            } else {
                this.props.toggleToast(res.msg, true);
            }

            this.setState({
                isShowManuallyLoading: false,
            })
        }
    }, 500)

    // 设置手动设置的开关状态
    setSwitchState = (tabkey) => {
        // 增加判断是否开启对应配置
        let { image_opt, alt_text, file_name } = this.state;
        let isImageCompression = Boolean(image_opt.switch) && ((tabkey === 0 && Boolean(image_opt.product)) || (tabkey === 1 && Boolean(image_opt.collection)) || (tabkey === 2 && Boolean(image_opt.blogs)));
        let isConvertImage = Boolean(image_opt.switch) && Boolean(image_opt.pngtojpg) && ((tabkey === 0 && Boolean(image_opt.product)) || (tabkey === 1 && Boolean(image_opt.collection)) || (tabkey === 2 && Boolean(image_opt.blogs)));
        let isAddWatermark = Boolean(image_opt.switch) && Boolean(image_opt.watermark.switch) && ((tabkey === 0 && Boolean(image_opt.product)) || (tabkey === 1 && Boolean(image_opt.collection)) || (tabkey === 2 && Boolean(image_opt.blogs)));
        let isImageAlttext = Boolean(alt_text.switch) && ((tabkey === 0 && Boolean(alt_text.product)) || (tabkey === 1 && Boolean(alt_text.collection)) || (tabkey === 2 && Boolean(alt_text.blogs)));
        let isImageFilename = Boolean(file_name.switch) && ((tabkey === 0 && Boolean(file_name.product)) || (tabkey === 1 && Boolean(file_name.collection)) || (tabkey === 2 && Boolean(file_name.blogs)));
        this.setState({
            isImageCompression,
            isConvertImage,
            isAddWatermark,
            isImageAlttext,
            isImageFilename,
        })

        return isImageCompression || isConvertImage || isAddWatermark || isImageAlttext || isImageFilename;
    }

    //拖动条
    handleRangeSliderChange = (value, name) => {
        this.setState({
            [name]: value,
            setSaveDisabled: false,
        });
    }

    //上传图片
    updateImageDrop = (files, acceptedFiles, rejectedFiles) => {
        this.setState({
            files: acceptedFiles[0],
            loadingLogo: true,
        }, () => {
            // 大于500kb提示
            if (files[0].type.indexOf('image') === -1 || files[0].type.indexOf('gif') > -1) {
                // this.props.toggleToast(t("File type must be .jpg .jpeg .png."), true);
            } else if (acceptedFiles[0].size > 500 * 1024) {
                this.setState({
                    showToast: false
                }, () => {
                    // this.props.toggleToast('watermark picture maximum size 500kb', true);
                })
            } else {
                this.setState({
                    setSaveDisabled: false,
                }, () => {
                    this.handleDropImage(1, acceptedFiles[0]);
                })
            }
        });
    };

    //图片数据加载
    handleDropImage = (type, acceptedFiles, img) => {
        let fileUpload = '';
        let uploadedFiles = '';
        let setUpdateImageWarning = '';
        let imageAddWatermarkImg = ""
        if (img) {
            fileUpload = !img && <DropZone.FileUpload actionTitle={t("Add file")} actionHint="(Maximum size 500kb)" />;
            if (!img) {
                this.setState({
                    showImageUploadBanner: true
                })
            }
            uploadedFiles = img && (
                <div className="addImage addImageBox">
                    <Thumbnail
                        size="small"
                        alt=''
                        source={PAGE_DOMAIN + img}
                    />
                </div>
            );
            this.setState({
                imgButton: false,
                fileUpload: fileUpload,
                uploadedFiles: uploadedFiles,
                setUpdateImageWarning: "",
                showImageUploadBanner: false,
            });
        } else if (acceptedFiles) {
            const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
            const filesImg = acceptedFiles
            if (validImageTypes.indexOf(filesImg.type) >= 0) {
                let imageData = [];
                fileUpload = !filesImg && <DropZone.FileUpload actionTitle={t("Add file")} actionHint="(Maximum size 500kb)" />;
                if (!filesImg) {
                    this.setState({
                        showImageUploadBanner: true
                    })
                }
                //开启FileReader
                let reader = new FileReader();
                reader.readAsDataURL(filesImg); //读取文件保存在result中
                reader.onload = (e) => {
                    let getRes = e.target.result;//读取的结果在result中
                    imageData.push(
                        {
                            'name': filesImg.name,
                            'image': getRes,
                            'type': filesImg.type,
                        }
                    );

                    uploadedFiles = filesImg && (
                        <div className="addHerpImage">
                            <Thumbnail
                                size="small"
                                alt=""
                                source={getRes}
                            />
                        </div>
                    );
                    imageAddWatermarkImg = getRes;

                    this.setState({
                        imgButton: false,
                        fileUpload: fileUpload,
                        uploadedFiles: uploadedFiles,
                        imageAddWatermarkImg: imageAddWatermarkImg,
                        setUpdateImageWarning: "",
                        imageData: imageData,
                        showImageUploadBanner: false,
                    });
                }
            } else {
                fileUpload = <DropZone.FileUpload actionTitle={t("Add file")} actionHint="(Maximum size 500kb)" />;
                uploadedFiles = ''
                setUpdateImageWarning = <Banner
                    title={t("The following images couldn't be uploaded:")}
                    tone="critical"
                    onDismiss={() => {
                        this.setState({
                            setUpdateImageWarning: null
                        })
                    }}
                    action={{
                        content: t("Contact us"),
                        onAction: this.handleContactServiceShow
                    }}
                >
                    <List>
                        <List.Item>
                            {t("File type must be .jpg .jpeg .png.")}
                        </List.Item>
                    </List>
                    <p></p>
                </Banner>
                this.setState({
                    fileUpload: fileUpload,
                    uploadedFiles: uploadedFiles,
                    setUpdateImageWarning: setUpdateImageWarning,
                    imageAddWatermarkImg: imageAddWatermarkImg,
                    showImageUploadBanner: true,
                });
            }
        } else {
            fileUpload = <DropZone.FileUpload actionTitle={t("Add file")} actionHint="(Maximum size 500kb)" />;
            uploadedFiles = ''
            //如果提交的文件不是图片 就提醒报错
            if (type === 1) {
                setUpdateImageWarning = <Banner
                    title={t("The following images couldn't be uploaded:")}
                    tone="critical"
                    onDismiss={() => {
                        this.setState({
                            setUpdateImageWarning: null
                        })
                    }}
                    action={{
                        content: t("Contact us"),
                        onAction: this.handleContactServiceShow
                    }}
                >
                    <List>
                        <List.Item>
                            {t("File type must be .jpg .jpeg .png.")}
                        </List.Item>
                    </List>
                </Banner>
            }
            if (Number(this.state.imageAddWatermarkSwitch)) {
                this.setState({
                    fileUpload: fileUpload,
                    uploadedFiles: uploadedFiles,
                    setUpdateImageWarning: setUpdateImageWarning,
                    imageAddWatermarkImg: imageAddWatermarkImg,
                    showImageUploadBanner: true
                });
            } else {
                this.setState({
                    fileUpload: fileUpload,
                    uploadedFiles: uploadedFiles,
                    setUpdateImageWarning: setUpdateImageWarning,
                    imageAddWatermarkImg: imageAddWatermarkImg,
                });
            }
        }
    }
    //删除图片
    deleteImage = () => {
        this.setState({
            files: '',
            imgButton: true,
            dataHasChange: true,
            showImageUploadBanner: true,
            imageAddWatermarkImg: ''
        }, () => {
            this.handleDropImage();
        });
    }

    //下拉框
    handleSelectChange = (e) => {
        this.setState({
            imageAddWatermarkPosition: e,
            setSaveDisabled: false,
        });
    }

    // 改版历史记录表tab
    handleTypeTabskeyChange = (e) => {
        this.setState({
            historyTabKey: e,
            historyTabLoading: true,
            historyTableData: [],
            historyQueryVal: '',
            hPage: 1,
            hPageSize: 10,
            progressCp: 0,
            progressAll: 0,
        }, () => {
            this.deleteTimeFunc(); // 删除订阅器
            this.getOptHistoryTable();
            this.getOptSchedule();
        })
    }

    // 历史记录搜索
    changeHistoryQueryVal = (val) => {
        this.setState({
            historyQueryVal: val,
        }, () => {
            this.getOptHistoryTable();
        })
    }

    // 历史表格 分页
    changeHitoryTablePageData = (e) => {
        this.setState({
            hPage: Number(e),
            historyTabLoading: true,
        }, () => {
            this.getOptHistoryTable();
        })
    }

    // 历史表格 页数
    changeHitoryTablePageSizeData = (e) => {
        this.setState({
            hPage: 1,
            hPageSize: Number(e),
            historyTabLoading: true,
        }, () => {
            this.getOptHistoryTable();
        })
    }

    // 历史表格 失去焦点
    handleImageAltPageBlur = (e) => {
        this.setState({
            hPage: Number(e),
        }, () => {
            this.getOptHistoryTable();
        })
    }

    // 停止优化
    stopImageOptimize = async () => {
        this.setState({
            stopLoading: true
        })
        const res = await reqStopImageOptTask();
        if (res.ack === 1) {
            this.props.toggleToast(res.msg, false)
            this.setState({
                stopLoading: false,
                isShowManuallyBtnLoading: false,
                isInLoading: false,
                allOptType: false,
                isShowProgress: -1,
                progressCp: 0,
                progressAll: 0,
            }, () => {
                this.getOptHistoryTable();
                this.deleteTimeFunc();
            })
        } else {
            this.setState({
                stopLoading: false,
            })
            this.props.toggleToast(res.msg, true)
        }
    }

    // 设置手动 批量数据
    setManuallyTableItemData = (data) => {
        this.setState({
            manuallyTableState: data,
        })
    }

    // 单个恢复 - 历史表格 集合和博客
    RestoreHitoryImageData = (data) => {
        let { historyTabKey, historyTableData } = this.state;
        let list = cloneDeep(historyTableData);
        list.forEach(item => {
            if (item['id'] === data['id'] && !Boolean(item['restoreLoadingId'].includes(data['id']))) {
                item['restoreLoadingId'].push(data['id']);
            }
        })
        this.setState({
            historyTableData: list
        }, async () => {
            let params = {
                data_type: historyTabKey + 1,
                data_list: [
                    {
                        data_id: historyTabKey === 1 ? data['coll_id'] : data['art_id'],
                        restore_type: ''
                    }
                ],
                handle_type: 1,
            }
            const res = await reqBatchRestore(params);
            list.forEach(item => {
                let indexId = item['restoreLoadingId'].indexOf(data['id']);
                if (item['id'] === data['id'] && indexId > -1) {
                    item['restoreLoadingId'].splice(indexId, 1);
                }
            })
            if (res.ack === 1) {
                // this.setState({
                //   historyTableData: list
                // }, () => {
                this.props.toggleToast(res.msg, false);
                // this.getOptHistoryTable(false);
                setTimeout(() => {
                    this.getOptSchedule();
                }, 3000)
                // })
            } else {
                this.setState({
                    historyTableData: list
                }, () => {
                    this.props.toggleToast(res.msg, true)
                })
            }
        })
    }

    // 批量恢复 - 历史表格
    BatchReHitoryImageData = (objData) => {
        let { historyTabKey, historyTableData } = this.state;
        this.setState({
            batchLoading: true,
            isShowProgress: historyTabKey,
            optType: 'restore'
        }, async () => {
            let dataList = [];
            objData[0].forEach(item => {
                historyTableData.forEach(data => {
                    if (item === data['id'] && data['is_delete'] !== 1) {
                        if (historyTabKey === 0) {
                            dataList.push({
                                data_id: data['prod_id'],
                            })
                        } else if (historyTabKey === 1) {
                            dataList.push({
                                data_id: data['coll_id'],
                            })
                        } else if (historyTabKey === 2) {
                            dataList.push({
                                data_id: data['art_id'],
                                blog_id: data['blog_id'],
                            })
                        } else {
                            dataList.push({
                                data_id: data['id'],
                            })
                        }
                    }
                })
            })
            let params = {
                data_type: historyTabKey + 1,
                data_list: dataList,
                restore_type: objData[1] ? 'all' : '',
                handle_type: 1,
            }
            if (dataList.length === 0) {
                // let tips = historyTabKey === 0 ? 'product' : historyTabKey === 1 ? 'collection' : 'blog';
                // this.props.toggleToast(`Select the correct state of the ${tips} data operation`, false);
                this.props.toggleToast("Please select items", false);
                this.setState({
                    batchLoading: false,
                    isShowProgress: -1,
                    optType: '',
                })
                return false;
            }
            const res = await reqBatchRestore(params);
            if (res.ack === 1) {
                this.props.toggleToast(res.msg, false);
                setTimeout(() => {
                    this.getOptSchedule();
                }, 3000)
            } else {
                this.setState({
                    batchLoading: false,
                    isShowProgress: -1,
                    optType: '',
                })
                this.props.toggleToast(res.msg, true);
            }
        })
    }

    // 批量重新优化 - 历史表格
    BatchOptHitoryImageData = (objData) => {
        let { historyTabKey, historyTableData } = this.state;
        this.setState({
            batchLoading: true,
            isShowProgress: historyTabKey,
            optType: 're-Optimize',
            optPageType: 0
        }, async () => {
            let dataList = [];
            objData[0].forEach(item => {
                historyTableData.forEach(data => {
                    if (item === data['id'] && data['is_delete'] !== 1) {
                        if (historyTabKey === 0) {
                            dataList.push({
                                data_id: data['prod_id'],
                            })
                        } else if (historyTabKey === 1) {
                            dataList.push({
                                data_id: data['coll_id'],
                            })
                        } else if (historyTabKey === 2) {
                            dataList.push({
                                data_id: data['art_id'],
                                blog_id: data['blog_id'],
                            })
                        } else {
                            dataList.push({
                                data_id: data['id'],
                            })
                        }
                    }
                })
            })
            let params = {
                data_type: historyTabKey + 1,
                data_list: dataList,
                re_opt_type: objData[1] ? 'all' : '',
                page_type: 0,
                handle_type: 1,
            }
            if (dataList.length === 0) {
                // let tips = historyTabKey === 0 ? 'product' : historyTabKey === 1 ? 'collection' : 'blog';
                // this.props.toggleToast(`Select the correct state of the ${tips} data operation`, false);
                this.props.toggleToast("Please select items", false);
                this.setState({
                    batchLoading: false,
                    isShowProgress: -1,
                    optType: '',
                    optPageType: 0
                })
                return false;
            }
            const res = await reqBatchReOptimize(params);
            if (res.ack === 1) {
                this.props.toggleToast(res.msg, false);
                setTimeout(() => {
                    this.getOptSchedule();
                }, 3000)
            } else {
                this.setState({
                    batchLoading: false,
                    isShowProgress: -1,
                    optType: '',
                })
                this.props.toggleToast(res.msg, true);
            }
        })
    }

    // 保存设置
    saveSetData = async (type) => {
        let {
            auto_switch,
            is_default,
            image_opt,
            isShowImgCompression,
            isShowImgAltText,
            isShowImgFilename,
            productImg,
            ColImg,
            BlogImg,
            ConvertImg,
            AddWaterImg,
            imageAddWatermarkPosition,
            imageAddWatermarkSize,
            imageAddWatermarkOpacity,
            productAlt,
            ColAlt,
            BlogAlt,
            blankImgAlt,
            productFile,
            ColFile,
            BlogFile,
            proAltTag,
            colAltTag,
            blogAltTag,
            proFileTag,
            colFileTag,
            blogFileTag,
            imageAddWatermarkImg,
            imageData,
        } = this.state;
        // 判断是否自动开关还是设置保存
        let params = {};
        if (type === 'switch') {
            params = {
                auto_switch: Number(auto_switch),
            }
        } else {
            let tagActive = [];
            if (isShowImgAltText) {
                if (productAlt && !Boolean(proAltTag.replace(/[\s\n\u200B]/g, ""))) {
                    tagActive.push('ProductAltFixTag');
                }
                if (ColAlt && !Boolean(colAltTag.replace(/[\s\n\u200B]/g, ""))) {
                    tagActive.push('ColAltFixTag');
                }
                if (BlogAlt && !Boolean(blogAltTag.replace(/[\s\n\u200B]/g, ""))) {
                    tagActive.push('BlogAltFixTag');
                }
            }
            if (isShowImgFilename) {
                if (productFile && !Boolean(proFileTag.replace(/[\s\n\u200B]/g, ""))) {
                    tagActive.push('ProductFileFixTag');
                }
                if (ColFile && !Boolean(colFileTag.replace(/[\s\n\u200B]/g, ""))) {
                    tagActive.push('ColFileFixTag');
                }
                if (BlogFile && !Boolean(blogFileTag.replace(/[\s\n\u200B]/g, ""))) {
                    tagActive.push('BlogFileFixTag');
                }
            }
            this.setState({
                tagActive,
            })
            if (tagActive.length > 0) {
                // this.props.toggleToast('The input value cannot be empty', false);
                return false;
            }
            params = {
                alt_text: {
                    blogs: Number(BlogAlt),
                    switch: Number(isShowImgAltText),
                    product: Number(Boolean(productAlt) ? productAlt : 0),
                    blogs_rule: this.changeTagFormat('blog', blogAltTag),
                    collection: Number(ColAlt),
                    product_rule: this.changeTagFormat('product', proAltTag),
                    blank_replace: Number(blankImgAlt),
                    collection_rule: this.changeTagFormat('collection', colAltTag),
                },
                file_name: {
                    blogs: Number(BlogFile),
                    switch: Number(isShowImgFilename),
                    product: Number(Boolean(productFile) ? productFile : 0),
                    blogs_rule: this.changeTagFormat('blog', blogFileTag),
                    collection: Number(ColFile),
                    product_rule: this.changeTagFormat('product', proFileTag),
                    collection_rule: this.changeTagFormat('collection', colFileTag)
                },
                is_default: is_default,
                auto_switch: Number(auto_switch),
                image_opt: {
                    switch: Number(isShowImgCompression),
                    product: Number(Boolean(productImg) ? productImg : 0),
                    collection: Number(ColImg),
                    blogs: Number(BlogImg),
                    pngtojpg: Number(ConvertImg),
                    quality: image_opt?.quality,
                    watermark: {
                        switch: Number(AddWaterImg),
                        logo: imageAddWatermarkImg,
                        // file_data: imageAddWatermarkImg,
                        // file_name: Boolean(imageData) && imageData.length > 0 ? imageData[0].name : '',
                        position: imageAddWatermarkPosition,
                        image_height: Number(Number(imageAddWatermarkSize / 100).toFixed(2)),
                        opacity: Number(imageAddWatermarkOpacity)
                    }
                }
            }
            if (imageAddWatermarkImg.indexOf('base64') > -1) {
                params['image_opt']['watermark']['file_data'] = imageAddWatermarkImg;
                params['image_opt']['watermark']['file_name'] = Boolean(imageData) && imageData.length > 0 ? imageData[0].name : '';
                params['image_opt']['watermark']['logo'] = "";
            }
        }
        this.setState({
            setSaveLoading: true,
        })
        const res = await reqSaveSettings(params);
        if (res.ack === 1) {
            this.props.toggleToast(res.msg, false);
            this.setState({
                setSaveDisabled: true,
                setSaveLoading: false,
            }, () => {
                this.getProductStatistics(params['is_default'] ? true : false, null);
                setTimeout(() => {
                    if (type !== 'switch') {
                        this.setState({
                            firstSetSheetActive: false,
                        })
                    }
                }, 1000)
            })
        } else {
            this.props.toggleToast(res.msg, true);
            this.setState({
                setSaveDisabled: false,
                setSaveLoading: false,
            })
        }

        return res;
    }

    //点击联系客服
    handleContactService = async (content) => {
        // window.Intercom('showMessages');
        // window.$crisp.push(["do", "chat:open"])
        try {
            if (content === "image compression") {
                // window.Intercom('showNewMessage', 'Hi,Can you increase the "image compression" quota for me?');
                // window.$crisp.push(["set", "message:text", ['Hi,Can you increase the "image compression" quota for me?']])
                showNewMessage('Hi,Can you increase the "image compression" quota for me?')
            } else if (content === "image on-page compression") {
                showNewMessage('Hi,Can you increase the "image compression" and “On-Page SEO Product” quota for me?')
            } else {
                showNewMessage();
            }
            const params = {
                'path': window.location.pathname,
                'content': content
            };
            await reqUpdateCustomerClick(params);
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    handleContactServiceShow = () => {
        try {
            showNewMessage()
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 关闭额度banner
    closeQuotaBanner = () => {
        this.setState({
            isShowQuotaImage: false,
        }, () => {
            try {
                sessionStorage.setItem('quotaBannerImage', 0);
            } catch (e) { }
        })
    }

    // 跳转升级额度
    jumpGetMore = () => {
        let { level } = this.state;
        if (level !== 3) {
            this.jumpPricing();
        } else {
            this.jumpSettings();
        }
    }

    // 关闭获取更多额度
    closeGetMoreQuota = () => {
        this.setState({
            isShowGetMore: false,
        }, () => {
            try {
                sessionStorage.setItem('getMoreQuotaBanner', 'close');
            } catch (e) { }
        })
    }

    // 返回
    goBack = () => {
        utils.routeJump(this, '/speedOpt')
    }

    // 关闭增量提示
    closeOverCharge = () => {
        this.setState({
            isShowOverCharge: false,
        })
    }

    // 跳转价格页
    jumpPricing = () => {
        utils.routeJump(this, "/plan")
    }

    // 跳转设置页
    jumpSettings = () => {
        utils.routeJump(this, "/settings", null, 'overage');
    }

    // 跳转速度优化
    jumpSpeedUrl = () => {
        utils.routeJump(this, "/speedOpt/site-speedup")
    }

    // 关闭cw广告
    closeImageCwAdver = () => {
        this.setState({
            isShowCwAdverImage: false,
        }, () => {
            this.requestStateSet('cwAdverImageState', 1);
        })
    }

    // 关闭功能下架提示
    closeUnderFuncAdver = () => {
        this.setState({
            isShowUnderFunc: false,
        }, () => {
            try {
                sessionStorage.setItem('isShowUnderFunc', 'close');
            } catch (e) { }
        })
    }

    // 重新优化
    handleReOptimize = () => {
        let { isReOpt } = this.state;
        this.setState({
            isReOpt: !isReOpt,
            isDisabledReOpt: !isReOpt
        })
    }

    // 批量状态
    setTableSelect = (val) => {
        this.setState({
            isReOpt: val,
            isDisabledReOpt: val
        })
    }

    // 发送请求
    requestStateSet = async (type, state) => {
        const params = {
            name: `${type}`,
            st: Number(state),
            exp: 0,
            type: `param`
        }
        const res = await reqSaveSwitchState(params);
        if (res.ack === 1) {
            let data = cloneDeep(this.props.public.publicInit.head_data?.switch_data)
            if (typeof data === 'boolean') {
                data = [];
            }
            data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": 1, "exp": 0 };
            this.props.setSwitchData(data);
        } else {
            // this.props.toggleToast(t("Try again later"), true);
        }
    }

    componentWillUnmount() {
        // 删除订阅器
        this.deleteTimeFunc();
        this.clearHistoryArr();
        this.setState = () => false;
    }

    render() {
        const {
            loadingPage,
            level,
            // FirstSetActive,
            isShowImgCompression,
            isShowAutoState,
            is_default,
            // total_saved_size,
            // avg_saved_space,
            // avg_saved_percent,
            impressionsUse,
            impressionsAll,
            // impressionsProportion,
            // freeQuota,
            image_opt,
            hPage,
            hPageSize,
            historyQueryVal,
            historyTabKey,
            historyTableData,
            historyTabLoading,
            historyTableRes,
            isShowManuallyBtnLoading,
            isShowProgress,
            progressCp,
            progressAll,
            optType,
            // stopLoading,
            optPageType,
            batchLoading,
            historyyPre,
            historyNext,
            allOptType,
            exceedUse,
            exceedAll,
            is_capped,
            is_over_quota,
            // isShowOverCharge,
            historyTabLoadingShow,
            isShowMaxLimitState,
            // un_opt_num,
            // total_speed_increase,
            // isShowUnderFunc,
            // impressionsPro,
            // exceedPro,
            handleTypePro,
            handleTypeCol,
            handleTypeBlog,
            isReOpt,
            isDisabledReOpt,

        } = this.state;

        // 首次设置弹窗
        // 完成icon
        // const checkIcon = <svg viewBox="0 0 20 20" className="Icon_Icon__uZZKy" width={20} height={20}><path fillRule="evenodd" d="M15.78 5.97a.75.75 0 0 1 0 1.06l-6.5 6.5a.75.75 0 0 1-1.06 0l-3.25-3.25a.75.75 0 1 1 1.06-1.06l2.72 2.72 5.97-5.97a.75.75 0 0 1 1.06 0Z"></path></svg>
        // const firstModalTip = <Modal
        //     open={FirstSetActive}
        //     onClose={() => this.handleStateChange('FirstSetActive', false)}
        //     title={"✨ " + t("Get Started with Smarter Images in {{v1}} Seconds!", 60)}
        //     primaryAction={{
        //         content: t("Start Optimizing ({{v1}}s)", 60) + " →",
        //         onAction: this.openFirstSetUp,
        //     }}
        // >
        //     <Modal.Section>
        //         <div className='setting_info'>
        //             <p>🚀{t("Automate your image workflow with SEOWILL!")}:</p>
        //             <span>{checkIcon} {t("Compress images without quality loss")}</span>
        //             <span>{checkIcon} {t("Boost SEO with auto-generated alt text")}</span>
        //             <span>{checkIcon} {t("Add watermarks & rename files effortlessly")}</span>
        //         </div>
        //     </Modal.Section>
        // </Modal>

        // 进度条面板
        const showPanelCd = (!isShowAutoState && isShowProgress !== -1 && isShowProgress === historyTabKey && ((handleTypePro === 1 && historyTabKey === 0) || (handleTypeCol === 1 && historyTabKey === 1) || (handleTypeBlog === 1 && historyTabKey === 2)));
        const progressPanel = showPanelCd ? <Card>
            <div className='opt_progress_hitory pro_panel'>
                <BlockStack gap={200}>
                    <div className='flex_layout'>
                        <div className='flex_layout auto_opt_tip'>
                            <Text variant="headingXs" as="h6">
                                {
                                    optType === 'restore' ? t("Restoring") : (optType === 're-Optimize' && optPageType === 0) ? t("Re-optimizing") : ""
                                }
                            </Text>
                            <Spinner size='small' />
                            {!(isShowManuallyBtnLoading && !allOptType) ? null : <Button variant='plain' onClick={this.stopImageOptimize}>{t("Stop this optimization")}</Button>}
                        </div>
                        <span>{t("completed /all")}:&nbsp;&nbsp;{progressCp}/{progressAll}</span>
                    </div>
                    {
                        progressAll > 0 && <ProgressBar tone='primary' progress={Number(((progressCp / progressAll) * 100).toFixed(0))} size='small' />
                    }
                </BlockStack>
            </div>
        </Card> : null;

        // 优化历史
        const OptimizationHistory = is_default === 0 && <div className='opt_history_box'>
            <BlockStack gap={600}>
                <div className='flex_layout opt_history_top'>
                    <Text variant="headingLg" as="h2">{t("Optimization History")}</Text>
                    {
                        isShowAutoState ? <Tooltip content={t("This feature is only available when the 'Auto Add Image Alt Text' function is disabled.")}>
                            <Button disabled>{t("Re-optimize")}</Button>
                        </Tooltip> : <Button disabled={isDisabledReOpt || (showPanelCd && optType === 'restore') || historyTableData.length === 0} loading={(showPanelCd && optType === 're-Optimize' && optPageType === 0)} onClick={this.handleReOptimize}>{t("Re-optimize")}</Button>
                    }
                </div>
                <BlockStack gap={400}>
                    {progressPanel}
                    <Card padding={0}>
                        <OptHistoryTable
                            page={hPage}
                            pageSize={hPageSize}
                            queryValue={historyQueryVal}
                            tabKey={historyTabKey}
                            tableData={historyTableData}
                            isShowAutoState={isShowAutoState}
                            image_opt={image_opt}
                            tableLoading={historyTabLoading}
                            tableRes={historyTableRes}
                            isShowProgress={isShowProgress}
                            progressCp={progressCp}
                            progressAll={progressAll}
                            optType={optType}
                            optPageType={optPageType}
                            getEventAction={this.getEventAction}
                            handleTypeTabskeyChange={this.handleTypeTabskeyChange}
                            changeHistoryQueryVal={this.changeHistoryQueryVal}
                            changeHitoryTablePageData={this.changeHitoryTablePageData}
                            changeHitoryTablePageSizeData={this.changeHitoryTablePageSizeData}
                            handlePageBlur={this.handleImageAltPageBlur}
                            RestoreHitoryImageData={this.RestoreHitoryImageData}
                            BatchReHitoryImageData={this.BatchReHitoryImageData}
                            BatchOptHitoryImageData={this.BatchOptHitoryImageData}
                            openSettingCard={this.openSettingCard}
                            loading={batchLoading}
                            impressionsUse={impressionsUse}
                            impressionsAll={impressionsAll}
                            level={level}
                            exceedUse={exceedUse}
                            exceedAll={exceedAll}
                            is_capped={is_capped}
                            is_over_quota={is_over_quota}
                            isShowImgCompression={isShowImgCompression}
                            historyyPre={historyyPre}
                            historyNext={historyNext}
                            isShowMaxLimitState={isShowMaxLimitState}
                            handleTypePro={handleTypePro}
                            handleTypeCol={handleTypeCol}
                            handleTypeBlog={handleTypeBlog}
                            isReOpt={isReOpt}
                            setTableSelect={this.setTableSelect}
                        />
                    </Card>
                </BlockStack>
            </BlockStack>
        </div>

        // 最终页面
        const PageContentInfo = (!loadingPage && historyTabLoadingShow !== -1) ? OptimizationHistory : <BlockStack gap={400}>
            <SkeletonDisplayText />
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        return PageContentInfo;
    }
}


const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({
    // 缓存自动开关状态
    setImageAutoSwitch(data) {
        dispatch(setImageAutoSwitchData(data));
    },

    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    },

    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['ImageOptimization', data]));
    },
})
indexClass = connect(
    mapStateToProps,
    mapDispatchToProps
)(indexClass);

export default withRouter(indexClass);
